<template>
    <b-container class="p-0">
        <b-modal centered id="choose_answer_modal" hide-footer hide-header>
            <b-row class="correct-answer mx-lg-3">
                <b-col>
                    <div class="correct-answer-list" >
                        <div class="correct-answer-item mb-3" v-for="(item, index) in value.correctAnswer" :key="index" @click="answerChoose(index)" >
                            <span>{{ item.data.value }}</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
        <div class="rw-choose-correct-answer">
            <text-input class="h5" v-if="value.label1" :value="value.label1.data"/>
            <text-input class="" v-if="value.label2" :value="value.label2.data"/>
            <b-row>
                <b-col cols="6" >
                    <b-card v-if="value.correctAnswer">
                        <div class="correct-answer-list" >
                            <div class="correct-answer-item mb-3" v-for="(item, index) in value.correctAnswer" :key="index">
                                <span>{{ item.data.value }}</span>
                            </div>
                        </div>
                    </b-card>
                </b-col>
                <b-col cols="6">
                    <b-card v-if="value.question">
                        <div class="question-list" v-for="(item, index) in value.question" :key="index" @click="chooseAnswer(index)">
                            <div class="question-item">
                                <div class="question ql-editor" v-html="item.text.data.value">
                                </div>
                                <div class="answer">
                                    <div class="answer-choose">
                                        <span>{{ item.choose }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>

import TextInput from './components/TextInput.vue'
import {
    BRow,
    BCol,
    BCard,
    BModal,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_choose_corect_answer',
    components: {
        TextInput,
        BRow,
        BCol,
        BCard,
        BModal,
        BContainer,
    },
    props: {
        value: Object
    },
    created() {
        if (this.value.question) {
            for (let index = 0; index < this.value.question.length; index++) {
                this.$set(this.value.question[index], 'choose', '')
            }
        }
    },
    data () {
        return {
            questionChooseAnswer: null,
            answer: [],
        }
    },
    methods: {
        answerChoose(index) {
            this.answer[this.questionChooseAnswer] = index
            if (this.value.question) {
                this.value.question[this.questionChooseAnswer].choose = this.value.correctAnswer[index].data.value
            }
            this.$bvModal.hide('choose_answer_modal')
        },
        chooseAnswer(index) {
            this.questionChooseAnswer = index
            this.$bvModal.show('choose_answer_modal')
        },
    }
}
</script>

<style scoped>

#choose_answer_modal .correct-answer-item {
    background-color: #ffdeb2;
    padding: 5px 15px;
    border-radius: 5px;
    cursor: pointer;
}

.question-item .question {
    font-weight: 500;
}

.question-item .answer-choose {
    min-height: 40px;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid #c3c3c3;
    border-radius: 5px;
    cursor: pointer;
    padding: 6px;
}

.question-item {
    background-color: #e3e3e3;
    padding: 5px 10px;
    border-radius: 3px;
    margin-bottom: 20px;
}

</style>